import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Header from "../components/Header";
import PwaInstallPrompt from "../components/PwaInstallPrompt";
import QuickTaskFab from "../components/QuickTaskFab";
import Sidebar from "./Sidebar";
import { garantirSincronizacaoAutomatica } from "../services/captureQueue";
import {
  garantirInscricaoSincronizada,
  sincronizarTokenComServiceWorker,
} from "../services/pushClient";
import "./AppLayout.css";

const AppLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    // Drena lembretes capturados offline em qualquer tela autenticada.
    garantirSincronizacaoAutomatica();
    // O service worker precisa do JWT para as acoes da notificacao.
    sincronizarTokenComServiceWorker();
    // Quem ja autorizou notificacoes tem a inscricao deste navegador conferida
    // com o servidor a cada abertura: e o que conserta sozinho o navegador que
    // rotacionou a inscricao e ficou mudo.
    garantirInscricaoSincronizada();
  }, []);

  return (
    <div className="app-layout">

      <Sidebar
        open={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
      />

      <div className="layout-main">

        <Header
          onToggleSidebar={() =>
            setSidebarOpen(!sidebarOpen)
          }
        />

        <main className="layout-content">
          <Outlet />
        </main>

        <PwaInstallPrompt />
        <QuickTaskFab />

      </div>

    </div>
  );
};

export default AppLayout;
